import { Typography, Box, Container, Link, Grid } from "@mui/material";
export const FooterPage = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(to right bottom, #010101, #454545)", // Fons degradat
        color: "white", // Text blanc
        py: 3, // Padding vertical
      }}
    >
      <Container maxWidth="lg">
        {/* Columna 2: Avís legal i privacitat */}
        {/* <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold" }}
              textAlign="center"
            >
              Sobre nosaltres
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8 }}
              textAlign="center"
            >
              Som un equip dedicat a ajudar-te a trobar el pis perfecte a
              Andorra. Ens encarreguem de buscar, filtrar i avisar-te quan
              trobem opcions que encaixin amb les teves necessitats.
            </Typography>
          </Grid>
        </Grid> */}
        <Box
          mt={3}
          sx={{
            display: "flex",
            justifyContent: "center", // Centra els enllaços
            gap: 3, // Espai entre enllaços
            flexWrap: "wrap", // Permet que els enllaços saltin de línia en pantalles petites
          }}
        >
          <Link href="/avis-legal" color="inherit" underline="hover">
            Avís legal
          </Link>
          <Link href="/privacitat" color="inherit" underline="hover">
            Política de privacitat
          </Link>
        </Box>
        {/* Copyright */}
        <Box mt={6} textAlign="center">
          <Typography variant="body2" color="#9ca3af">
            © {new Date().getFullYear()} buscopis.com - Tots els drets
            reservats.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
